import * as React from 'react';
import classnames from 'classnames';
import { Navigation } from './Navigation.js';
import { useCheckoutSettings } from '../../context/CheckoutSettings/context.js';

const NavigationContainer = ({ currentStep , disabledSteps , isLoggedIn , onNavigate  })=>{
    const checkoutSettings = useCheckoutSettings();
    var _routes;
    const routes = (_routes = checkoutSettings.routes) !== null && _routes !== void 0 ? _routes : {};
    const handleClick = React.useCallback((route)=>{
        onNavigate && onNavigate(route);
    }, [
        onNavigate
    ]);
    const navigationRoutes = Object.entries(routes).filter(([key])=>key !== 'callback' && key !== 'completed'
    );
    return /*#__PURE__*/ React.createElement("nav", {
        className: "checkout-nav"
    }, navigationRoutes.map(([step, route], index)=>{
        const currentStepIndex = Object.keys(routes).indexOf(currentStep);
        const isDisabled = index > currentStepIndex || disabledSteps && disabledSteps.includes(step);
        const classNames = classnames('checkout-nav-step', {
            'checkout-nav-step--active': step === currentStep,
            'checkout-nav-step--disabled': isDisabled,
            'checkout-nav-step--completed': index < currentStepIndex && !isDisabled
        });
        return /*#__PURE__*/ React.createElement(Navigation, {
            classNames: classNames,
            handleClick: handleClick,
            index: index,
            isLoggedIn: isLoggedIn,
            key: step,
            step: step,
            route: route,
            isDisabled: isDisabled
        });
    }));
};

export { NavigationContainer };
//# sourceMappingURL=NavigationContainer.js.map
